import { gtb } from "./companies";
import { CustomApp } from "./types";

export const companies: [RegExp, CustomApp][] = [[/fordevents.live$/, gtb]];
